<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
    <loading></loading>
  </div>
</template>

<script>
import loading from "@/components/loading";
export default {
  name: "App",
  components: { loading },
};
</script>

<style>
/**全局设置*/
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

/**设置背景颜色*/
body {
  margin: 0;
  height: 100%;
  background: #fff;
}
.messageClass {
  z-index: 3000 !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue